import { combineReducers } from "redux";

import todoReducer from "./todos/todoReducer";
import filterReducer from "./filter/filterReducer";
import statusReducer from "./todos/statusReducer";

const rootReducer = combineReducers({
  todo: todoReducer,
  filter: filterReducer,
  stat: statusReducer,
});

export default rootReducer;
